<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        <v-dialog v-model="dialog.delete"
          @keydown.esc="dialog.delete = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              Hapus Data

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second mt-4">
              Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">Item</b> yang Anda pilih?
            </v-card-text>

            <div v-if="message.error.length > 0"
              class="text-center mx-6 my-4">
              <div
                class="error--text d-flex align-start">
                <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                
                <span
                  class="ml-1">
                  {{ message.error }}
                </span>
              </div>
            </div>

            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                rounded
                width="120"
                @click="deletes()"
                :loading="process.delete"
                :disabled="process.delete"
                color="green"
                elevation="0"
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, Hapus
              </v-btn>

              <v-btn
                rounded
                width="120"
                @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
                :disabled="process.delete"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.komfirmasi"
            @keydown.esc="dialog.komfirmasi = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
              :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
              class="pa-8 pt-6">
              <v-card-title 
                class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
                
                Peringatan
  
                <v-spacer/>
  
                <!-- <v-icon 
                  @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                  class="cursor-pointer mr-1"
                  size="24"
                  color="#718EBF">
                  {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
                </v-icon>
  
                <v-icon 
                  @click="dialog.komfirmasi = false; dialog.fullscreen = false; selected.status = [];"
                  class="cursor-pointer"
                  size="24"
                  color="red">
                  mdi-close-circle-outline
                </v-icon> -->
  
                <v-icon 
                  @click="dialog.komfirmasi = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                  class="cursor-pointer"
                  size="18"
                  color="#000000">
                  mdi-close
                </v-icon>
              </v-card-title>
              
              <!-- <v-divider 
                class="mb-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-text 
                class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
                Sebelum menyelesaikan penerimaan ini, pastikan Anda sudah mengisi Qty diterima pada setiap item yang ada.

              </v-card-text>
  
  
              <!-- <v-divider 
                class="mt-2"
                style="border-top: 2px dashed #e0e0e0;"/> -->
  
              <v-card-actions
                class="pa-0 pt-4">
                <v-spacer/>
  
                <v-btn
                  @click="dialog.selesai = true; dialog.komfirmasi = false;"
                  :loading="process.form"
                  :disabled="process.form"
                  elevation="0"
                  color="green"
                  rounded
                  class="body-2 font-weight-bold text-capitalize white--text">
                  Ya, Sudah
                </v-btn>
  
                <!-- <v-btn
                  rounded
                  width="120"
                  @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                  :disabled="process.status"
                  outlined
                  class="body-2 font-weight-bold text-capitalize red--text">
                  Batal
                </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>
        
        <v-dialog v-model="dialog.status"
          @keydown.esc="dialog.status = false"
          :fullscreen="dialog.fullscreen"
          width="500"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
            class="pa-8 pt-6">
            <v-card-title 
              class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
              
              Mengubah Status

              <v-spacer/>

              <!-- <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                color="#718EBF">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon> -->

              <v-icon 
                @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
                class="cursor-pointer"
                size="18"
                color="#000000">
                mdi-close
              </v-icon>
            </v-card-title>
            
            <!-- <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-text 
              class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
              Apakah Anda yakin mengubah status perubahan data menjadi <b class="font-weight-bold black--text">di{{ message.status }}</b> ?

              <!-- <div>
                <ValidationObserver 
                  ref="form">
                  <v-form>

                    <div
                      class="mb-6 mt-5"  v-if="message.status === 'tolak'">
                      <ValidationProvider 
                        name="Alasan" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Alasan
                        </div>

                        <v-textarea
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
                          rows="3"
                          solo

                          :color="set_color"
                          placeholder="Contoh. Tuliskan alasan disini . . ."


                          v-model="rejected_reason"
                          :error-messages="errors"
                          style="border-radius: 10px;">
                        </v-textarea>
                      </ValidationProvider>
                    </div>
                    

                    <div
                      class="mb-6 mt-5" v-if="message.status === 'terima' && approved_by.length > 0">
                      <ValidationProvider 
                        name="Alasan" 
                        rules="required" 
                        v-slot="{ errors }">
                        <div class="body-2 mb-2">
                          <span class="red--text">*</span>
                          Alasan
                        </div>

                        <v-textarea
                          v-on:keyup.enter="save()"
                          
                          filled
                          rounded
                          dense
                          rows="3"
                          solo

                          :color="set_color"
                          placeholder="Contoh. Tuliskan alasan disini . . ."


                          v-model="approved_reason"
                          :error-messages="errors"
                          style="border-radius: 10px;">
                        </v-textarea>
                      </ValidationProvider>
                    </div>
                    
                  </v-form>
                </ValidationObserver>
              </div> -->

              <div v-if="message.error.length > 0"
                class="text-left mt-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>


            <!-- <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/> -->

            <v-card-actions
              class="pa-0 pt-4">
              <v-spacer/>

              <v-btn
                @click="saveStatus()"
                :loading="process.form"
                :disabled="process.form"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Ya, {{ message.status }}
              </v-btn>

              <!-- <v-btn
                rounded
                width="120"
                @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
                :disabled="process.status"
                outlined
                class="body-2 font-weight-bold text-capitalize red--text">
                Batal
              </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Terima Item {{ list.length !== 0 ? list[selected.form].item_name : '' }}
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <ValidationProvider
                    name="Qty" 
                    rules="required|min_value:0" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Qty di Minta
                    </div>

                    <v-currency-field              
                      rounded
                      dense
                      filled
                      hide-details

                      color="#718EBF"
                      placeholder="Qty"
                      :error-messages="errors"
                      readonly
                      :suffix="form.satuan"

                      class="mb-6"

                      v-model="form.qty"
                      
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="form.qty !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-currency-field>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Qty Diterima" 
                    :rules="`required|min_value:0`" 
                    v-slot="{ errors }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Qty Diterima
                    </div>
                    <div class="d-flex align-center">
                      <div style="width: 100%;">
                    <v-currency-field              
                      rounded
                      dense
                      filled
                      hide-details

                      color="#718EBF"
                      placeholder="Qty"
                      :error-messages="errors"
                      :suffix="form.satuan"
                      :auto-decimal-mode="false"

                      class="mb-6"
                      :decimal-length="2"

                      v-model="form.accepted_qty"
                      
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <!-- <div v-if="form.accepted_qty !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div> -->
                      </template>
                    </v-currency-field>
                  </div>
                      <div>
                        <v-btn
                          @click="form.accepted_qty = form.qty"
                          :loading="process.form"
                          :disabled="process.form"
                          elevation="0"
                          color="green"
                          style="border-radius: 10px;"
                          class="body-2 font-weight-bold text-capitalize white--text mb-6 ml-2">
                          Sama
                        </v-btn>
                      </div>
                    </div>
                  </ValidationProvider>

                  <ValidationProvider
                    name="Qty Diterima" 
                    :rules="`required|min_value:0`" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2">
                      <span class="red--text">*</span>
                      Harga Satuan
                    </div>
                    
                        <v-currency-field              
                          rounded
                          dense
                          filled
                          hide-details
    
                          color="#718EBF"
                          placeholder="Harga yg Diterima"
                          :error-messages="errors"
    
                          class="mb-6"
    
                          v-model="form.acc_price"
                          
                          required
                          prefix="Rp. "
                          style="border-radius: 10px;">
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                            
                            <div v-if="form.acc_price !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-currency-field>
                      
                  </ValidationProvider>

                  <div class="body-2 mb-2">
                    <!-- <span class="red--text">*</span> -->
                    Harga Total
                  </div>
                  
                  <v-currency-field              
                    rounded
                    dense
                    filled
                    hide-details

                    color="#718EBF"
                    placeholder="Harga Total"
                    :error-messages="errors"

                    class="mb-6"
                    readonly
                    prefix="Rp. "

                    :value="form.acc_price * form.accepted_qty"
                    
                    required
                    style="border-radius: 10px;">
                  </v-currency-field>

                  <div class="body-2 mb-2">
                    Catatan
                  </div>
                  <v-textarea
                    filled
                    rounded
                    dense
                    rows="3"
                    
                    hide-details
                    
                    :color="set_color"
                    placeholder="Contoh. Tuliskan catatan disini . . ."

                    v-model="form.qty_diterima_note"
                    style="border-radius: 10px;">
                  </v-textarea>
                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="save()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.form = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.selesai"
          @keydown.esc="dialog.selesai = false"
          :fullscreen="dialog.fullscreen"
          width="600"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'">
            <v-card-title 
              class="d-flex align-center pa-4 text-right popup-header">
              <div
                class="title font-weight-bold">
                Selesaikan Proses
              </div>

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.selesai = false; dialog.fullscreen = false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider 
              class="mb-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-text 
              class="py-0 my-4">
              <ValidationObserver 
                ref="form">
                <v-form>
                  <!-- <div class="body-2 mb-2">
                    <span class="red--text">*</span>

                    Waktu Diterima
                  </div>
                  <v-menu
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                    >
                    <template v-slot:activator="{ on, attrs }">
                      <ValidationProvider 
                        name="Waktu Diterima" 
                        rules="required" 
                        v-slot="{ errors }">
                        <v-text-field
                          v-model="selesaikan.datetime"
                          
                          v-on:keyup.enter="savePenerimaan()"
                          
                          
                          filled
                          rounded
                          dense
                          
                          :color="set_color"
                          placeholder="Waktu Diterima"
    
                          hide-details
                        
    
                          :error-messages="errors"
                          required
                          style="border-radius: 10px;"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          >
                          <template v-slot:append-outer>
                            <div v-if="errors.length > 0">
                              <v-tooltip top color="#ff5252">
                                <template v-slot:activator="{ on }">
                                  <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                                </template>
                                
                                {{ errors[0] }}
                              </v-tooltip>
                            </div>
                            
                            <div v-if="selesaikan.datetime !== '' && valid">
                              <v-icon color="success">mdi-check-circle-outline</v-icon>
                            </div>
                          </template>
                        </v-text-field>
                      </ValidationProvider>
                    </template>
                    <v-date-picker
                      v-model="selesaikan.datetime"
                      @input="menu2 = false"
                    ></v-date-picker>
                  </v-menu>

                  <ValidationProvider
                    name="Petugas Penerima" 
                    :rules="`required`" 
                    v-slot="{ errors, valid }">
                    <div class="body-2 mb-2 mt-6">
                      <span class="red--text">*</span>
                      Petugas Penerima
                    </div>

                    <v-autocomplete
                      v-on:keyup.enter="savePenerimaan()"

                      filled
                      rounded
                      dense

                      :color="set_color"
                      placeholder="Petugas Penerima"

                      hide-details

                      :items="[{
                        id: 1,
                        name: 'Petugas 1'
                      }, {
                        id: 2,
                        name: 'Petugas 2'
                      }, {
                        id: 3,
                        name: 'Petugas 3'
                      }, {
                        id: 4,
                        name: 'Petugas 4'
                      }, {
                        id: 5,
                        name: 'Petugas 5'
                      }]"
                      item-text="name"
                      item-value="id"
                      :item-color="set_color"

                      v-model="selesaikan.user_id"
                      :error-messages="errors"
                      required
                      style="border-radius: 10px;">
                      <template v-slot:append-outer>
                        <div v-if="errors.length > 0">
                          <v-tooltip top color="#ff5252">
                            <template v-slot:activator="{ on }">
                              <v-icon color="error" v-on="on">mdi-alert-circle-outline</v-icon>
                            </template>
                            
                            {{ errors[0] }}
                          </v-tooltip>
                        </div>
                        
                        <div v-if="selesaikan.user_id !== '' && valid">
                          <v-icon color="success">mdi-check-circle-outline</v-icon>
                        </div>
                      </template>
                    </v-autocomplete>
                  </ValidationProvider> -->

                  <div class="body-2 mb-2">
                    <!-- <span class="red--text">*</span> -->
                    Lampiran Bukti Penerimaan
                  </div>
                  <uploadfolder
                    v-model="upload.image" 
                    style="height: 250px; width: 250px">
                    <div 
                      slot="activator"
                      class="cursor-pointer">
                      <v-card 
                        flat
                        height="250"
                        class="d-flex align-center justify-center"
                        style="border-radius: 15px;
                              border: 2px solid #eaeaea; 
                              border-style: dashed;">
                        <div v-if="selesaikan.bukti_url.length < 1">
                          <v-icon v-if="!process.image"
                            size="60" 
                            color="#718EBF">
                            mdi-cloud-upload-outline
                          </v-icon>
  
                          <v-progress-circular v-else
                            indeterminate
                            :color="set_color">
                          </v-progress-circular>
                        </div>
  
                        <v-img v-else
                          contain
                          height="250"
                          :src="selesaikan.bukti_url" 
                          :alt="selesaikan.bukti_url"
                          class="text-center d-flex align-center">
                          <div 
                            class="d-flex aling-center justify-center" 
                            style="width: 100%; height: auto;">
                            <v-icon v-if="!process.image"
                              size="60" 
                              color="white">
                              mdi-cloud-upload-outline
                            </v-icon>
  
                            <v-progress-circular v-else
                              indeterminate
                              :color="set_color">
                            </v-progress-circular>
                          </div>
                        </v-img>
                      </v-card>
                    </div>
                  </uploadfolder>

                </v-form>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center mt-6">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>
            
            <v-divider 
              class="mt-2"
              style="border-top: 2px dashed #e0e0e0;"/>

            <v-card-actions
              class="pa-4">
              <v-spacer/>

              <v-btn
                @click="savePenerimaan()"
                :loading="process.form"
                :disabled="process.form"
                width="120"
                elevation="0"
                color="green"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Simpan
              </v-btn>

              <v-btn
                @click="dialog.selesai = false; reset();"
                :disabled="process.form"
                width="120"
                outlined
                elevation="0"
                color="red"
                rounded
                class="body-2 font-weight-bold text-capitalize white--text">
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                to="/pembelian/penerimaan"
                flat
                color="transparent"
                style="width: 100%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="22"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="POS Amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="fs-16 black--text ml-3"
                    style="font-weight: 600;">
                    Detail Penerimaan
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pb-0 pr-1">
            <v-col 
              cols="12"
              class="py-0">
              <div style="">
                <v-card v-if="process.load && Object.keys(detail).length < 1"
                  flat
                  style="border-radius: 10px; border: 1px solid #E7E7E7;">
                  <v-card-text
                    class="pb-0 my-4" style="height: 500px; display: flex; align-items: center; justify-content: center;">
                    <div class="text-center">
                      <div class="mb-2 title">
                        Mohon Tunggu...
                      </div>
                      <v-progress-circular
                        indeterminate
                      ></v-progress-circular>
                    </div>
                  </v-card-text>
                </v-card>
  
                <div v-if="!process.load && Object.keys(detail).length > 0" class="px-4">
                  <v-card flat class="mt-0">
                    <v-card-text class="pt-0 px-0">
                      <v-row>
                        <v-col cols="12" md="6">
                          <v-card flat style="background: #E1F5FE; border-radius: 10px;" height="100%">
                            <v-card-text>
                              <div class="d-flex">
                                <div class="mb-5">
                                  <div>
                                    No. Permintaan
                                  </div>
                                  <div class="fs-16 font_weight_600 black_one">
                                    {{ detail.request_number }}
                                  </div>
                                </div>
                                <div class="mb-5 ml-auto">
                                  <div>
                                    <v-tooltip bottom v-if="detail.status === 'Diterima'">
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="exports()"
                                          :loading="process.export"
                                          elevation="0"
                                          dark
                                          min-height="28"
                                          small
                                          min-width="28"
                                          color="#bd1112"
                                          class="text-capitalize px-0 mr-2"
                                          style="border-radius: 6px;"
                                          v-bind="attrs"
                                          v-on="on">
                                          <v-icon size="18" color="white">mdi-file-pdf-box</v-icon>
                                        </v-btn>
                                      </template>

                                      <span>
                                        Export Pdf
                                      </span>
                                    </v-tooltip>
                                    <v-chip
                                      class="ma-0"
                                      :style="detail.status === 'Ditolak' || detail.status === 'Dibatalkan' ? 'color: white;' : detail.status === 'Disetujui' ? 'color: white;' : detail.status === 'Diproses' ? 'color: white;' : 'color: black;'"
                                      :color="detail.status === 'Ditolak' || detail.status === 'Dibatalkan' ? 'red' : detail.status === 'Disetujui' ? 'green' : detail.status === 'Diproses' ? 'blue' : detail.status === 'Diterima' ? 'grey lighten-3' : 'yellow'"
                                    >
                                      {{ detail.status }}
                                    </v-chip>
                                  </div>
                                </div>
                              </div>
                              <div class="mb-5">
                                <div>
                                  Tanggal Permintaan
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ detail.date | date }}
                                </div>
                              </div>
                            </v-card-text>
                          </v-card>
                        </v-col>
                        <v-col cols="12" md="6">
                          <v-card flat>
                            <v-row>
                              <v-col cols="12" md="6" class="py-0">
                                <v-card flat style="background: #E8F5E9; border-radius: 10px;">
                                  <v-card-text>
                                    <div>
                                      Total Realisasi Belanja
                                    </div>
                                    <div class="title black_one font_weight_600">
                                      {{ harga_beli_terima | price }}
                                    </div>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                              <v-col cols="12" md="6" class="py-0">
                                <v-card flat style="background: #F5F5F5; border-radius: 10px;">
                                  <v-card-text>
                                    <div>
                                      Total Perkiraan Belanja
                                    </div>
                                    <div class="title black_one font_weight_600">
                                      {{ harga_beli | price }}
                                    </div>
                                  </v-card-text>
                                </v-card>
                              </v-col>
                              <v-col cols="12" md="12" class="pb-0">
                                <v-card flat style="background: #FCE4EC; border-radius: 10px;">
                                  <v-card-text>
                                    <div>
                                      Selisih
                                    </div>
                                    <div class="title black_one font_weight_600">
                                      {{ selisih | price }}
                                    </div>
                                  </v-card-text>
                                </v-card>
                              </v-col>

                            </v-row>
                          </v-card> 
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                  <!-- <v-card
                    flat
                    style="border-radius: 10px; border: 1px solid #E7E7E7;">
                    <v-card-text>
                      <div class="d-flex">
                        <div class="mb-5">
                          <div>
                            No. Permintaan
                          </div>
                          <div class="fs-16 font_weight_600 black_one">
                            {{ detail.request_number }}
                          </div>
                        </div>
                        <div class="mb-5 ml-auto">
                          <div>
                            <v-chip
                              class="ma-0"
                              :style="detail.status === 'Ditolak' || detail.status === 'Dibatalkan' ? 'color: white;' : detail.status === 'Disetujui' ? 'color: white;' : detail.status === 'Diproses' ? 'color: white;' : 'color: black;'"
                              :color="detail.status === 'Ditolak' || detail.status === 'Dibatalkan' ? 'red' : detail.status === 'Disetujui' ? 'green' : detail.status === 'Diproses' ? 'blue' : detail.status === 'Diterima' ? 'grey lighten-3' : 'yellow'"
                            >
                              {{ detail.status }}
                            </v-chip>
                          </div>
                        </div>
                      </div>
                      <div class="mb-5">
                        <div>
                          Tanggal Permintaan
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          {{ detail.date | date }}
                        </div>
                      </div>
                    </v-card-text>
                  </v-card> -->

                  <v-card
                    flat
                    v-if="detail.status === 'Diterima'"
                    class="mt-5"
                    style="border-radius: 10px; border: 1px solid #E7E7E7;">
                    <v-card-text>
                      <div class="d-flex">
                        <div class="mb-5" style="width: calc(100% / 3)">
                          <div>
                            NO Penerimaan
                          </div>
                          <div class="fs-16 font_weight_600 black_one">
                            {{ detail.accepted_number }}
                          </div>
                        </div>
                        <div class="mb-5" style="width: calc(100% / 3)">
                          <div>
                            Diterima Oleh
                          </div>
                          <div class="fs-16 font_weight_600 black_one">
                            {{ detail.accepted_admin_name }}
                          </div>
                        </div>
                        <div class="mb-5" style="width: calc(100% / 3)">
                          <div>
                            Tanggal Diterima
                          </div>
                          <div class="fs-16 font_weight_600 black_one">
                            {{ detail.accepted_datetime | datetime }}
                          </div>
                        </div>
                      </div>
                      <div class="mb-5">
                        <div>
                          Bukti Penerimaan 
                        </div>
                        <div class="fs-16 font_weight_600 black_one">
                          <div v-if="detail.accepted_bukti_terima === '' || detail.accepted_bukti_terima === null">-</div>
                          <div v-else>
                            <v-img
                              width="150"
                              height="150"
                              contain
                              :src="detail.accepted_bukti_terima">
                            </v-img>
                          </div>
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
  
                  <!-- <v-card flat
                    v-if="detail_item.length < 1">
                    <v-card-text
                      class="pb-0 my-4" style="height: calc( 100vh - 350px ); display: flex; align-items: center; justify-content: center;">
                      <div class="text-center">
                        <v-img 
                          class="mx-auto"
                          contain
                          alt="vuetify"
                          :width="90"
                          :height="90"
                          :src="require('@/assets/image/empty.png')">
                        </v-img>
                        <div class="mt-3 fs-18">
                          Belum Ada Item
                        </div>
                      </div>
                    </v-card-text>
                  </v-card>
  
                  <div class="mt-5" v-if="detail_item.length > 0">
                    <div v-for="(item, index) in detail_item" :key="index">
                      <v-card flat class="mb-5" style="    background: #f0f8ff80; border-radius: 10px; border: 1px solid #f1f1f1;">
                        <v-card-text>
                          <div class="d-flex">
                            <div>
                              <div class="fs-16 font-weight-bold black_one">
                                {{ items[index].name_label }}
                              </div>
                              <div>
                                Kategori: <span class="font_weight_600">{{ items[index].category_item_name }}</span>
                              </div>
                              <div>
                                Harga Beli: <span class="font_weight_600">{{ items[index].purchase_price | price }} / {{ item.satuan }}</span>
                              </div>
                              <v-img 
                                class="mr-auto mt-2"
                                contain
                                alt="vuetify"
                                :width="50"
                                :height="50"
                                :src="items[index].image_url">
                              </v-img>
                            </div>
  
                            <div class="ml-auto text-right">
                              <v-tooltip 
                                top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                  
                                    @click="dialog.delete = true; selected = index;"
  
                                    v-bind="attrs"
                                    v-on="on"
  
                                    min-width="24" min-height="24"
                                    x-small
                                    rounded
                                    color="red"
                                    elevation="0"
                                    class="white--text text-capitalize mx-1 px-0 mb-2"
                                    style="font-weight: 600; border-radius: 6px;">
                                    <v-icon size="15">mdi-trash-can-outline</v-icon>
                                  </v-btn>
                                </template>
                                
                                <span>Hapus</span>
                              </v-tooltip>
  
                              
                            </div>
                            
                          </div>
  
                          <v-row class="mt-4">
                            <v-col cols="4" class="py-0">
                              <div>
                                Harga Beli
                              </div>
                            </v-col>
                            <v-col cols="4" class="py-0">
                              <div>
                                Qty
                              </div>
                            </v-col>
                            <v-col cols="4" class="text-right py-0">
                              <div>
                                Total
                              </div>
                            </v-col>
  
                            <v-col class="py-0" cols="4">
                              <div class="fs-16 font_weight_600 black_one">
                                {{ items[index].purchase_price | price }} / {{ item.satuan }}
                              </div>
                            </v-col>
                            <v-col class="py-0" cols="4">
                              <div class="fs-16 font_weight_600 black_one">
                                {{ item.qty*1 }}
                              </div>
                            </v-col>
                            <v-col cols="4" class="py-0 text-right">
                              <div class="fs-16 font_weight_600 black_one">
                                {{ (item.qty*1) * (items[index].purchase_price*1) | price }}
                              </div>
                            </v-col>
  
                            <v-col class="" cols="4">
                              <div>
                                <div>
                                  Supplier
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.supplier_name }}
                                </div>
                              </div>
                            </v-col>
  
                            <v-col class="py-0" cols="12">
                              <div>
                                <div>
                                  Catatan
                                </div>
                                <div class="fs-16 font_weight_600 black_one">
                                  {{ item.note }}
                                </div>
                              </div>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </div>
                    <v-divider class="my-2"></v-divider>
                    <v-row>
                      <v-col>
                        <div class="fs-17 font_weight_600 text-left black_one">
                          Total Perkiraan Modal Belanja
                        </div>
                      </v-col>
                      <v-col>
                        <div class="fs-17 font_weight_600 text-right black_one">
                          {{ total_nominal | price }}
                        </div>
                      </v-col>
                    </v-row>
                  </div> -->
                </div>
  
                <v-card flat class="mt-0">
                  <v-card-text class="pt-0">
                    <div class="mb-3 d-flex">
                      <div class="fs-17 font_weight_600 black_one">Data Item</div>
                      <div class="ml-auto">
                        <v-btn
                          :to="`/pembelian/penerimaan/add_item/${$route.params.id}`"
                          color="#4B4B4B"
                          elevation="0"
                          v-if="detail.status === 'Disetujui'"
                          class="body-2 white--text text-capitalize d-flex align-center"
                          style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                          <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                          
                          <span
                            class="ml-2">
                            Tambah
                          </span>
                        </v-btn>
                      </div>
                    </div>

                    <v-row>
                      <v-col 
                        cols="12"
                        class="py-0">
                        <v-card 
                          flat
                          style="border-radius: 10px; border: 1px solid #E7E7E7;">
                          <v-data-table
                            v-model="selected.row"
                            ref="table-grid"
                            class="table-grid"
                            :height="`calc(100vh - 490px)`"
                            :show-select="checkbox"
                            :single-select="true"
                            :loading="process.load"
                            loading-text="Sedang memuat data . . ."
                            loader-height="5"
                            no-results-text="Belum ada data"
                            :options.sync="options"
                            :headers="configHeaders"
                            :items="list"
                            :items-per-page="100"
                            item-key="id"
                            @click:row="rowClick"
                            @toggle-select-all="handleToggleAll($event)"
                            @dblclick:row="doubleClick"
                            hide-default-footer>
                            <template
                              v-for="header in configHeaders.filter((header) => header.hasOwnProperty('format'))"
                                v-slot:[`item.${header.value}`]="{ value, index }">
                              <div
                                v-bind:key="header.value">
                                <div v-if="header.format !== 'regex' && header.format !== 'image' && header.format !== 'image_potrait' && header.format !== 'image_landscape' && header.format !== 'action' && header.format !== 'bool' && header.format !== 'status' && header.format !== 'link'">
                                  {{ rowFormat(header.format, value) }} 
                                </div>
    
                                <div v-if="header.format === 'link'"
                                  class="cursor-pointer">
                                  
                                </div>
                  
                                <div v-if="header.format === 'regex'">
                                  <span
                                    class="two-line">
                                    {{ rowFormat(header.format, value) }}
                                  </span>
                                </div>
                  
                                <div v-if="header.format === 'image'"
                                  class="ma-4">
                                  <v-avatar
                                    size="60"
                                    tile
                                    style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                    <v-img 
                                      contain
                                      width="100%"
                                      height="100%"
                                      alt="POS Amanata" 
                                      :src="value !== '' ? value : require('@/assets/image/member_default.png')"
                                      class="ma-auto">
                                      <template v-slot:placeholder>
                                        <v-row
                                          class="fill-height"
                                          align="center"
                                          justify="center">
                                          <v-progress-circular 
                                            size="20"
                                            indeterminate 
                                            :color="set_color">
                                          </v-progress-circular>
                                        </v-row>
                                      </template>
                                    </v-img>
                                  </v-avatar>
                                </div>
    
                                <div v-if="header.format === 'image_potrait'"
                                  class="ma-4">
                                  <v-img 
                                    contain
                                    width="100"
                                    height="125"
                                    alt="POS Amanata" 
                                    :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                    class="ma-auto"
                                    style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          size="20"
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </div>
    
                                <div v-if="header.format === 'image_landscape'"
                                  class="ma-4">
                                  <v-img 
                                    contain
                                    width="200"
                                    height="125"
                                    alt="POS Amanata" 
                                    :src="value !== '' ? value : require('@/assets/image/image_default.png')"
                                    class="ma-auto"
                                    style="border: 2px dashed #e0e0e0; border-radius: 8px !important;">
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center">
                                        <v-progress-circular 
                                          size="20"
                                          indeterminate 
                                          :color="set_color">
                                        </v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </div>
    
                                <div v-if="header.format === 'action'">
                                  <div v-if="detail.status !== 'Disetujui' && detail.status !== 'Diproses'">
                                    <v-chip class="ma-0"
                                      :style="detail.status === 'Ditolak' || detail.status === 'Dibatalkan' ? 'color: white;' : detail.status === 'Disetujui' ? 'color: white;' : detail.status === 'Diproses' ? 'color: white;' : 'color: black;'"
                                      :color="detail.status === 'Ditolak' || detail.status === 'Dibatalkan' ? 'red' : detail.status === 'Disetujui' ? 'green' : detail.status === 'Diproses' ? 'blue' : detail.status === 'Diterima' ? 'grey lighten-3' : 'yellow'"
                                    >
                                      {{ detail.status }}
                                    </v-chip>
                                  </div>
                                  <div v-else>
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                          @click="detail.status === 'Disetujui' || detail.status === 'Diproses' ? toEdit(index) : ''"
      
                                          v-bind="attrs"
                                          v-on="on"
                                          :disabled="detail.status !== 'Disetujui' && detail.status !== 'Diproses'"
      
                                          min-width="24" min-height="24"
                                          x-small
                                          rounded
                                          color="blue"
                                          elevation="0"
                                          class="white--text text-capitalize mx-1"
                                          style="font-weight: 600; border-radius: 6px;">
                                          <v-icon size="15">mdi-check-circle</v-icon> 
                                          <div class="ml-2">
                                            Terima Item
                                          </div>
                                        </v-btn>
                                      </template>
      
                                      <span>Tambahkan Qty diterima</span>
                                    </v-tooltip>
                                  </div>
    
    
                                  <!-- <v-tooltip 
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        @click="detail.status === 'Menunggu' ? toDelete(value) : ''"
    
                                        v-bind="attrs"
                                        v-on="on"
    
                                        min-width="24" min-height="24"
                                        :disabled="detail.status !== 'Menunggu'"
                                        x-small
                                        rounded
                                        color="red"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon size="15">mdi-trash-can-outline</v-icon>
                                      </v-btn>
                                    </template>
    
                                    <span>Hapus</span>
                                  </v-tooltip> -->
                                </div>
                                
                              </div>
                            </template>
    
                            <template v-slot:[`item.index`]="{ index }">
                              {{ lastIndex + index }}
                            </template>
    
                            <v-progress-linear 
                              v-show="process.load" 
                              slot="progress" 
                              color="white" 
                              indeterminate>
                            </v-progress-linear>
                          </v-data-table>
    
                          <!-- <pagination v-if="pagination.total_data > 0"
                            @changePage="fetch($event)" 
                            @reloadPage="fetch($event)" 
                            :model="pagination" :display="paginationList"/> -->
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </div>

              <v-card v-if="!process.load && Object.keys(detail).length > 0"
                flat>
                <v-card-actions
                  class="px-4">
                  <v-spacer/>

                  <v-btn
                    @click="dialog.komfirmasi = true; message.success = ''; message.error = ''; reset();"
                    :disabled="process.form"
                    v-if="detail.status === 'Disetujui' || detail.status === 'Diproses'"
                    color="indigo"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4"
                    style="border-radius: 10px; font-weight: 600;">
                    <v-icon 
                      size="20">
                      mdi-check-circle
                    </v-icon>

                    <span
                      class="ml-2">
                      Selesaikan
                    </span>
                  </v-btn>

                  <!-- <v-btn
                    @click="dialog.status = true; message.success = ''; message.error = ''; message.status = 'tolak';"
                    :disabled="process.form"
                    v-if="detail.status === 'Menunggu'"
                    color="orange"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4"
                    style="border-radius: 10px; font-weight: 600;">
                    <v-icon 
                      size="20">
                      mdi-cancel
                    </v-icon>

                    <span
                      class="ml-2">
                      Ditolak
                    </span>
                  </v-btn> -->
                  
                  <v-btn
                    to="/pembelian/penerimaan"
                    :disabled="process.form"
                    color="red"
                    elevation="0"
                    class="body-2 white--text text-capitalize d-flex align-center ml-4"
                    style="border-radius: 10px; font-weight: 600;">
                    <v-icon 
                      size="20">
                      mdi-progress-close
                    </v-icon>

                    <span
                      class="ml-2">
                      Kembali
                    </span>
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        checkbox: false,
        menu2: false,
        dialog: {
          fullscreen: false,
          snackbar: false,

          role: false,
          delete: false,
          form: false,
          status: false,
          selesai: false,
          komfirmasi: false
        },
        options: {},
        headers: [],
        list: [],
        pagination: {},
        paginationList: {},
        selected: {
          row: [],
          freeze: [],
          delete: [],
          reset: [],
          role: [],
          form: 0
        },
        harga_beli: 0,
        harga_beli_terima: 0,
        selisih: 0,

        selesaikan: {
          datetime: '',
          user_id: '',
          bukti_url: '',
        },

        form: {},
        supplier: [],

        lastIndex: 0,
        limit: 20,
        total_nominal: 0,
        detail: {},
        detail_item: [],
        items: [],
        upload: {
          image: null
        },
        // selected: 0,
        
        process: {
          load: false,

          delete: false,
          reset: false,
          role: false,
          form: false,
          status: false,
          image: false,
          export: false
        },
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      pagination: () => import(/* webpackPrefetch: true */ '@/components/pagination.vue'),
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.selesaikan.bukti_url = this.upload.image.fileuri

              // this.save_image()
            }
          }
        },
        deep: true
      },
      'options': {
        handler () {
          let pagination = { row: this.limit, page: 1 }
          
          this.fetch(pagination)
        },
        deep: true
      }
    },
    computed: {
      company () {
        return this.$store.state.company
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      user () {
        return this.$store.state.user
      },
      outlet () {
        return this.$store.state.outlet
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      },
      configHeaders () {
        return this.headers.filter(header => !header.hide)  
      }
    },
    beforeMount () {
    },
    mounted () {

      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id,
          outlet_id: this.outlet.outlet_id
        }

        await get(`pos/pembelian/penerimaan/data`, { params })
        .then(response => {
          let res = response.data

          // this.process.load = false
          // this.fetch()

          if (res.status === 200) {
            this.detail = res.results.data[0]
          }
        })
      },
      formatPrice(value) {
        let val = (value/1)
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
      async fetch (pagination = { row: 20, page: 1 }) {
        this.process.load = true

        this.limit = pagination.row
        this.paginationList = pagination

        let params = {
          limit: pagination.row,
          page: pagination.page,
          sort: this.options.sortBy.length < 1 ? '-detail_id' : this.options.sortBy[0],
          order_by: this.options.sortDesc[0] ? 'ASC' : 'DESC',
          request_id: this.$route.params.id
        }

        await get(`pos/pembelian/penerimaan/detail`, { params })
        .then(response => {
          let res = response.data

          if (res.status === 200) {
            this.items = []
            // this.detail_item = res.results.data
            this.detail_item = []
            res.results.data.map((item) => {
              this.detail_item.push({ 
                ...item,
                qty_satuan: `${item.qty*1} ${item.satuan}`,
                qty: item.qty*1,
                qty_diterima_satuan: `${item.qty_diterima*1} ${item.satuan}`,
                accepted_purchase_price: item.accepted_purchase_price*1,
                harga_satuan: this.formatPrice(item.purchase_price*1) + '/' + item.satuan,
                accepted_qty: '',
                total_perkiaran: (item.qty*1) * (item.purchase_price*1),
                acc_price: item.purchase_price*1,
                qty_diterima_note: item.qty_diterima_note,
                total: (item.qty_diterima*1) * (item.accepted_purchase_price*1),
                selisih: ((item.qty_diterima*1) * (item.accepted_purchase_price*1)) === 0 ? 0 : ((item.qty*1) * (item.purchase_price*1)) - ((item.qty_diterima*1) * (item.accepted_purchase_price*1)),
              })
            })
            
            this.detail_item.map((item) => {
              // this.total_nominal += (item.qty*1) * (item.purchase_price*1)
              this.harga_beli += (item.qty*1) * (item.purchase_price*1)
              this.harga_beli_terima += (item.qty_diterima*1) * (item.accepted_purchase_price*1)
              this.selisih = this.harga_beli_terima === 0 ? 0 : this.harga_beli - this.harga_beli_terima
            })

            this.headers = [
              {
                text: 'Aksi',
                // width: '80px',
                value: 'id',
                freeze: true,
                hide: false,
                align: 'center',
                format: 'action'
              },
              // {
              //   text: 'Nomor Induk Pegawai',
              //   width: '200px',
              //   value: 'nip',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Nama Item',
                width: '200px',
                value: 'item_name',
                freeze: true,
                hide: false
              },
              // {
              //   text: 'Nama Supplier',
              //   width: '200px',
              //   value: 'supplier_name',
              //   freeze: false,
              //   hide: false
              // },
              {
                text: 'Harga Beli',
                width: '200px',
                value: 'harga_satuan',
                freeze: false,
                hide: false,
              },
              {
                text: 'Qty di Minta',
                width: '150px',
                value: 'qty_satuan',
                freeze: false,
                hide: false
              },
              {
                text: 'Total Perkiraan Belanja',
                width: '250px',
                value: 'total_perkiaran',
                freeze: false,
                hide: false,
                format: 'number'
              },
              {
                text: 'Qty Diterima',
                width: '180px',
                value: 'qty_diterima_satuan',
                freeze: false,
                hide: false
              },
              {
                text: 'Harga Diterima',
                width: '180px',
                value: 'accepted_purchase_price',
                freeze: false,
                hide: false,
                format: 'number'
              },
              {
                text: 'Total harga beli diterima',
                width: '250px',
                value: 'total',
                freeze: false,
                hide: false,
                format: 'number'
              },
              {
                text: 'Selisih',
                width: '150px',
                value: 'selisih',
                freeze: false,
                hide: false,
                format: 'number'
              },
              {
                text: 'Catatan',
                width: '250px',
                value: 'qty_diterima_note',
                freeze: false,
                hide: false
              },
            ]
            this.list = this.detail_item
            this.pagination = res.results.pagination
            this.process.load = false

            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
            this.lastIndex = (pagination.page - 1) * pagination.row 
            this.lastIndex += 1

          }
        })
      },
      async fetchItem (id) {
        let params = {
          limit: 100000,
          outlet_id: this.outlet.outlet_id,
          id: id
        }
        
        await get('pos/pembelian/item/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            // this.detail_item.map((item) => {
            //   if(item.id === id) {
                this.items.push(res.results.data[0])
              this.detail_item.map((item, index) => {
                if(item.item_id === id) {
                  this.detail_item[index].name_label = res.results.data[0].name_label
                  this.detail_item[index].category_item_name = res.results.data[0].category_item_name
                  this.detail_item[index].satuan = res.results.data[0].satuan
                  this.detail_item[index].purchase_price = res.results.data[0].purchase_price
                  this.detail_item[index].total = (res.results.data[0].purchase_price*1) * item.qty
                  this.detail_item[index].harga_satuan = this.formatPrice(res.results.data[0].purchase_price) + '/' + res.results.data[0].satuan
                  this.total_nominal += (this.detail_item[index].qty*1) * (res.results.data[0].purchase_price*1)
                  if(index === this.detail_item.length - 1) {
                    this.process.load = false
                  }
                }
              })
  
              this.list = this.detail_item
              
  
            this.addFreezes()

            this.$vuetify.goTo(this.$refs['table-grid'], { container: this.$refs['table-grid'].$el.querySelector('div.v-data-table__wrapper') })

            if (this.headers.length < 7 && this.list.length > 0) this.getTableToResize()
  
  
              
            // })
            // this.item = []
            // res.results.data.map((item) => {
            //   this.item.push({ 
            //     ...item,
            //     qty: 0,
            //     note_permintaan: '',
            //     total: 0,
            //     supplier_id: '',
            //     supplier: []
            //   })
            // })
            // this.item.map((item) => {
            //   this.fetchSupplier(item.id)
            // })
            // this.item = res.results.data
          }
        })
      },
      toEdit(index) {
        // console.log(index)
        this.form = this.list[index]
        this.dialog.form = true
        this.selected.form = index
      },
      reset () {
        this.selesaikan = {
          datetime: '',
          user_id: '',
          bukti_url: '',
        }
      },
      async fetchSupplier (id) {
        let params = {
          limit: 100000,
          item_id: id
        }
        
        await get('pos/pembelian/item_supplier/data', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.supplier = res.results.data
          }
        })
      },
      rowFormat (format, value) {
        let data = value

        if (format === 'number') {
          if (isNaN(value)) return 'Not a Number'
          let price = ''

          const reverseNumber = value
            .toString()
            .split('')
            .reverse()
            .join('')
          const arrReverseNumber = [...Array(reverseNumber.length).keys()]

          arrReverseNumber.map(index => {
            if (index % 3 === 0) price += reverseNumber.substr(index, 3) + '.'
          })

          return `Rp ${
            price.split('', price.length - 1)
            .reverse()
            .join('')
          }`
        } else if (format === 'array') {
          let arr = []

          for (let i = 0; i < value.length; i++) {
            arr.push(value[i].label)
          }

          data = arr.join(', ')
        } else if (format === 'date') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY') : '-'
        } else if (format === 'time') {
          data = value.length > 0 ? moment(value).format('HH:mm') : '-'
        } else if (format === 'datetime') {
          data = value.length > 0 ? moment(value).format('D MMM, YYYY HH:mm') : '-'
        } else if (format === 'object') {
          data = value.createdby.name
        } else if (format === 'regex') {
          let regex = /(<([^>]+)>)/ig

          data = value.replace(regex, '')
        } else if (format === 'underscore') {
          let regex = /_/g

          data = value.replace(regex, ' ')
        } else if (format === 'on_off') {
          data = value ? 'Online' : 'Offline'
        } else if (format === 'g_m') {
          data = value ? 'Mandiri' : 'Group'
        } else if (format === 'v_a') {
          data = value ? 'Sudah Verifikasi' : 'Belum Verifikasi'
        } else if (format === 'y_n') {
          data = parseInt(value) ? 'Ya' : 'Tidak'
        } else if (format === 'percent') {
          data = Number(value) + ' %'
        } else if (format === 'action') {
          data = value
        } else if (format === 'bool') {
          data = value
        } else if (format === 'status') {
          data = value
        } else if (format === 'link') {
          data = value
        }  else {
          data = value ? 'Aktif' : 'Tidak Aktif'
        }

        return data
      },
      rowClick (item, row) {
        row.select(!row.isSelected ? true : false)
      },
      doubleClick (event, {item}) {
        // NO ACTION
      },
      handleToggleAll (event) {
        if (!event.value) this.selected.row = []
      },
      addFreezes () {
        this.removeFreezes()

        this.selected.freeze = []

        for (let i = 0; i < this.configHeaders.length; i++) {
          if (this.configHeaders[i].freeze) {
            // ADD TO SELECTOR
            this.selected.freeze.push({
              child: i + (this.checkbox ? 2 : 1),
              width: this.configHeaders[i].width.split('px')[0]
            })

            // LOOP STYLESHEET
            for (let f = 0; f < this.selected.freeze.length; f++) {
              let style = document.createElement('style'),
                  width = 0

              if (this.checkbox) {
                width = f < 1 ? '65' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) + 65 : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width) + 65
              } else {
                width = f < 1 ? '0' : 
                      f === 1 ? parseInt(this.selected.freeze[f - 1].width) : 
                      parseInt(this.selected.freeze[f - 2].width) + parseInt(this.selected.freeze[f - 1].width)
              }

              // ADD STYLESHET TO FREEZE
              style.innerHTML = `
                .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 5;
                  background: #FFFFFF;
                }

                .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
                  left: ${width}px;
                  z-index: 1;
                }
              `

              // ADD TO APPENDCHILD
              document.head.appendChild(style)
            }
          }
        }
      },
      removeFreezes () {
        // LOOP STYLESHEET
        for (let f = 0; f < this.selected.freeze.length; f++) {
          let style = document.createElement('style')
          
          // RESET STYLESHEET TO AUTO
          style.innerHTML = `
            .table-grid table > thead > tr > th:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
              background: #FFFFFF;
            }

            .table-grid table > tbody > tr > td:nth-child(${this.selected.freeze[f].child}) {
              left: auto;
              z-index: auto;
            }
          `

          // ADD TO APPENDCHILD
          document.head.appendChild(style)
        }
      },
      addHides () {
        if (this.headers.length < 6) this.getTableToResize()
      },
      getTableToResize () {
        let tables = document.getElementsByTagName('table')

        for (let i = 0; i < tables.length; i++) {
          this.resizableGrid(tables[i])
        }
      },
      resizableGrid (table) {
        let row = table.getElementsByTagName('tr')[0],
            cols = row ? row.children : undefined
        
        if (!cols) return
        
        table.style.overflow = 'hidden'
        
        let tableHeight = table.offsetHeight
        
        for (let i = 0; i < cols.length; i++) {
          let div = createDiv(tableHeight)
          cols[i].appendChild(div)
          cols[i].style.position = 'relative'

          setListeners(div)
        }

        function setListeners (div) {
          let pageX, curCol, nxtCol, curColWidth, nxtColWidth

          div.addEventListener('mousedown', e => {
            curCol = e.target.parentElement
            nxtCol = curCol.nextElementSibling
            pageX = e.pageX
            
            let padding = paddingDiff(curCol)
            
            curColWidth = curCol.offsetWidth - padding

            if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding
          })

          div.addEventListener ('mouseover', e => {
            e.target.style.borderRight = '2px solid #e0e0e0'
          })

          div.addEventListener ('mouseout', e => {
            e.target.style.borderRight = ''
          })

          document.addEventListener ('mousemove', e => {
            if (curCol) {
              let diffX = e.pageX - pageX
          
              if (nxtCol) nxtCol.style.width = (nxtColWidth - (diffX))+'px'

              curCol.style.width = (curColWidth + diffX)+'px'
            }
          })

          document.addEventListener ('mouseup', () => { 
            curCol = undefined
            nxtCol = undefined
            pageX = undefined
            nxtColWidth = undefined
            curColWidth = undefined
          })
        }

        function createDiv (height) {
          let div = document.createElement('div')

          div.style.top = 0
          div.style.right = 0
          div.style.width = '1px'
          div.style.position = 'absolute'
          div.style.cursor = 'col-resize'
          div.style.userSelect = 'none'
          div.style.height = height + 'px'
          div.style.background = '#e0e0e0'

          return div
        }

        function paddingDiff (col) {
          if (getStyleVal(col,'box-sizing') == 'border-box') {
            return 0
          }
          
          let padLeft = getStyleVal(col,'padding-left')
          let padRight = getStyleVal(col,'padding-right')

          return (parseInt(padLeft) + parseInt(padRight))
        }

        function getStyleVal (elm,css) {
          return (window.getComputedStyle(elm, null).getPropertyValue(css))
        }
      },
      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()

        if (isValid) {
          this.process.form = false
          this.list[this.selected.form] = this.form
          this.list[this.selected.form].qty_diterima = this.list[this.selected.form].accepted_qty
          this.list[this.selected.form].qty_diterima_satuan = `${this.list[this.selected.form].accepted_qty*1} ${this.list[this.selected.form].satuan}`
          this.list[this.selected.form].accepted_purchase_price = this.list[this.selected.form].acc_price*1
          this.list[this.selected.form].total = (this.list[this.selected.form].accepted_qty*1) * (this.list[this.selected.form].accepted_purchase_price*1)
          this.list[this.selected.form].selisih = ((this.list[this.selected.form].accepted_qty*1) * (this.list[this.selected.form].accepted_purchase_price*1)) === 0 ? 0 : ((this.list[this.selected.form].qty*1) * (this.list[this.selected.form].purchase_price*1)) - ((this.list[this.selected.form].accepted_qty*1) * (this.list[this.selected.form].accepted_purchase_price*1))
          this.dialog.form = false
          this.harga_beli_terima = 0
          this.list.map((item) => {
            this.harga_beli_terima += (item.qty_diterima*1) * (item.accepted_purchase_price*1)
            this.selisih = this.harga_beli_terima === 0 ? 0 : this.harga_beli - this.harga_beli_terima
          })

          // let url = this.form.id === '' ? 'pos/pembelian/category_item/add' : 'pos/pembelian/category_item/update'

          // SAVE TO REST API
          // await post('pos/pembelian/request/update_item', {
          //   data: this.form
          // })
          // .then(response => {
          //   let res = response.data
            
          //   this.process.form = false

          //   if (res.status === 200) {
          //     this.dialog.form = false

          //     this.dialog.snackbar = true
          //     this.message.success = res.message

          //     this.dialog.fullscreen = false

          //     this.fetchDetail()
          //     this.fetch(this.paginationList)

          //   } else {
          //     this.message.error = res.message
          //   }
          // })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async savePenerimaan () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate(),
              imgValid = this.selesaikan.bukti_url !== '' ? true : false
        if (this.selesaikan.bukti_url === '') {
          // this.message.error = 'Bukti terima harus diisi'
        }

        if (isValid) {
          this.process.form = true
          // this.detail.status = 'Selesai'
          // this.dialog.selesai = false

          // let url = this.form.id === '' ? 'pos/pembelian/category_item/add' : 'pos/pembelian/category_item/update'

          // SAVE TO REST API
          await post('pos/pembelian/penerimaan/accepted', {
            data: {
              request_id: this.$route.params.id,
              accepted_bukti_terima: this.selesaikan.bukti_url,
              detail_arr: JSON.stringify(
                this.list.map((item) => {
                  return {
                    detail_id: item.detail_id,
                    accepted_qty: item.accepted_qty,
                    accepted_purchase_price: item.acc_price,
                    qty_diterima_note: item.qty_diterima_note
                  }
                })
              )
            }
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message
              this.dialog.selesai = false

              this.dialog.fullscreen = false

              this.fetchDetail()
              this.fetch()

            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },
      async saveStatus () {
        this.message.error = ''

        this.process.form = true

        let params = {
          id: this.$route.params.id,
          status: this.message.status === 'setujui' ? 'Disetujui' : 'Ditolak'
        }

        await post(`pos/pembelian/request/approval`, { data: params })
        .then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {
            this.dialog.status = false

            this.fetchDetail()
            this.fetch(this.paginationList)
            this.dialog.snackbar = true
            this.message.success = res.message
            this.message.error = ''
          } else {
            this.message.error = res.message
          }
        })
      },
      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`pos/pembelian/request/delete_item`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetch(this.paginationList)
          } else {
            this.message.error = res.message
          }
        })
      },
      async exports () {
        this.message.error = ''

        this.process.export = true

        let params = {
          request_id: this.$route.params.id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}/pos/pembelian/penerimaan/export_pdf`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          // console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=\"')[1]
          let filename = ''

          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }
          // console.log(filename)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>